import type { ProductAssignmentModel } from '@/shared/generated'

import { ListFilterIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { getQueryDescription } from '@/shared/components/query-builder'
import {
	Card,
	CardContent,
	CardHeader,
	CardTitle,
} from '@/shared/components/ui/card'
import {
	Item,
	ItemContent,
	ItemDescription,
	ItemMedia,
	ItemTitle,
} from '@/shared/components/ui/item'
import { Tag } from '@/shared/components/ui/tag'

import { useFiltersParams } from '../lib/useFiltersParams'

export const AssignmentView = ({
	assignments,
}: {
	assignments: ProductAssignmentModel
}) => {
	const { t } = useTranslation()
	const { fields, dataChoices } = useFiltersParams()

	return (
		<Card className='w-full shadow-none'>
			<CardHeader>
				<CardTitle>
					{t('settings.assignment.long', {
						defaultValue: 'Product assignment',
					})}
				</CardTitle>
			</CardHeader>
			<CardContent className='flex w-full flex-col gap-4 divide-y'>
				{assignments.map((assignment) => (
					<Item key={assignment.name} size='sm' variant='muted'>
						<ItemMedia>
							<ListFilterIcon className='size-4 shrink-0 opacity-50' />
						</ItemMedia>
						<ItemContent>
							<ItemTitle className='font-semibold'>{assignment.name}</ItemTitle>
							<ItemDescription>
								<div className='flex flex-col gap-1'>
									{getQueryDescription(assignment.filters || [], {
										fields,
										dataChoices,
									}).map((item, index) => (
										<div
											key={`${item?.label}-${item?.operation}`}
											className='space-x-2 rounded-sm text-sm break-all'
										>
											<span>{index === 0 ? t('where') : t('and')}</span>
											<span className='font-semibold'>{item?.label}</span>
											<span className='rounded-sm'>{item?.operation}</span>
											<span className='rounded-sm font-medium text-muted-foreground'>
												{Array.isArray(item?.value)
													? item?.value.map((value) => (
															<Tag key={value}>{value}</Tag>
														))
													: item?.value}
											</span>
										</div>
									))}
								</div>
							</ItemDescription>
						</ItemContent>
					</Item>
				))}
			</CardContent>
		</Card>
	)
}
